import React, { useEffect, useState } from 'react';
import {
  Box, Typography, Paper, Tabs, Tab, Table, TableBody,
  TableCell, TableContainer, TableHead, TableRow, Chip,
  CircularProgress, IconButton
} from '@mui/material';
import { ContentCopy as CloneIcon, Delete as DeleteIcon } from '@mui/icons-material';
import apiClient from '../../api/client';

const SecurityCenter: React.FC = () => {
  const [tab, setTab] = useState(0);
  const [roles, setRoles] = useState<any[]>([]);
  const [auditLogs, setAuditLogs] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchRoles = async () => {
    setLoading(true);
    try {
      const response = await apiClient.get('/api/v1/security/roles');
      setRoles(response.data.content || []);
    } catch (err) {
      console.error("Failed to fetch roles");
    } finally {
      setLoading(false);
    }
  };

  const fetchAudit = async () => {
    setLoading(true);
    try {
      const response = await apiClient.get('/api/v1/security/audit');
      setAuditLogs(response.data || []);
    } catch (err) {
      console.error("Failed to fetch audit logs");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (tab === 0) fetchRoles();
    else fetchAudit();
  }, [tab]);

  return (
    <Box>
      <Typography variant="h4" gutterBottom>Security Center</Typography>

      <Paper sx={{ mb: 3 }}>
        <Tabs value={tab} onChange={(_, v) => setTab(v)}>
          <Tab label="Enterprise Roles" />
          <Tab label="Audit History" />
        </Tabs>
      </Paper>

      {loading ? <CircularProgress /> : (
        <>
          {tab === 0 && (
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Role Name</TableCell>
                    <TableCell>Type</TableCell>
                    <TableCell>Editable</TableCell>
                    <TableCell align="right">Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {roles.map((role) => (
                    <TableRow key={role.id}>
                      <TableCell>
                        <Typography variant="body1" fontWeight="medium">{role.name}</Typography>
                        <Typography variant="body2" color="textSecondary">{role.description}</Typography>
                      </TableCell>
                      <TableCell>
                        {role.system ? <Chip label="System" size="small" /> : <Chip label="Custom" color="primary" size="small" />}
                      </TableCell>
                      <TableCell>{role.editable ? 'Yes' : 'No'}</TableCell>
                      <TableCell align="right">
                        <IconButton size="small" title="Clone"><CloneIcon /></IconButton>
                        <IconButton size="small" color="error" disabled={!role.editable}><DeleteIcon /></IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}

          {tab === 1 && (
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Timestamp</TableCell>
                    <TableCell>User</TableCell>
                    <TableCell>Action</TableCell>
                    <TableCell>Status</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {auditLogs.map((log) => (
                    <TableRow key={log.id}>
                      <TableCell>{new Date(log.timestamp).toLocaleString()}</TableCell>
                      <TableCell>{log.userId}</TableCell>
                      <TableCell>{log.resource} / {log.action}</TableCell>
                      <TableCell>
                        <Chip
                          label={log.allowed ? 'ALLOWED' : 'DENIED'}
                          color={log.allowed ? 'success' : 'error'}
                          size="small"
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </>
      )}
    </Box>
  );
};

export default SecurityCenter;
